import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "41",
  height: "36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m35.875 3-1.708 1.5L35.875 3ZM5.125 3l1.708 1.5L5.125 3Zm30.75 21-1.708-1.5 1.708 1.5Zm-30.75 0 1.708-1.5L5.125 24Zm10.25 3h10.25-10.25Zm1.708 4.5h6.834-6.834Zm3.417-27c-6.833 0-10.332 2.925-10.25 7.5.04 2.23.854 3.75 2.563 5.25 1.708 1.5 2.562 2.25 2.562 5.25h10.25c0-3 .854-3.75 2.563-5.25 1.708-1.5 2.523-3.02 2.562-5.25.082-4.575-3.417-7.5-10.25-7.5Z",
  fill: "#000"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m35.875 3-1.708 1.5M5.125 3l1.708 1.5M35.875 24l-1.708-1.5M5.125 24l1.708-1.5m8.542 4.5h10.25m-8.542 4.5h6.834M20.5 4.5c-6.833 0-10.332 2.925-10.25 7.5.04 2.23.854 3.75 2.563 5.25 1.708 1.5 2.562 2.25 2.562 5.25h10.25c0-3 .854-3.75 2.563-5.25 1.708-1.5 2.523-3.02 2.562-5.25.082-4.575-3.417-7.5-10.25-7.5Z",
  stroke: "#000",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }